import axios, { AxiosError, AxiosRequestConfig, AxiosResponse } from 'axios';
import _ from 'lodash';

import { convertErrors } from '../error/errorHandler';
import { ErrorDetails } from '../error/model/errors';

import UserManager from './security/UserManager';

const customizedAxios = axios.create();

customizedAxios.interceptors.request.use(async (config) => {
    const user = await UserManager.getUser().then((user) => user);
    if (user) {
        config.headers.Authorization = `Bearer ${user.access_token}`;
        return config;
    } else {
        await UserManager.removeUser();
        return config;
    }
});

export class ApiError {
    public readonly globalErrors?: string[];
    public readonly message?: string;

    constructor(message?: string, globalErrors?: string[]) {
        this.globalErrors = globalErrors;
        this.message = message;
    }
}

export const apiRequest = async <T>(config: AxiosRequestConfig): Promise<T | ApiError> => {
    try {
        const response: AxiosResponse<T> = await customizedAxios(config);
        return response.data;
    } catch (error) {
        return handleAxiosError(error as AxiosError);
    }
};

const handleAxiosError = (error: AxiosError): ApiError => {
    if (error.response) {
        const errors: ErrorDetails[] | undefined = _.get(error, 'response.data.errors');
        if (errors) {
            const errorMessage = convertErrors(errors).globalErrors.map((error) => error.message);
            return new ApiError('', errorMessage);
        }
        return new ApiError(error.message || 'An unknown error occurred');
    } else if (error.request) {
        return new ApiError('Unable to connect to the server. Please check your connection.');
    } else {
        return new ApiError(error.message || 'An unknown error occurred');
    }
};
